<template>
  <div style="padding: 15px">
    <el-row>
      <el-col :span="24">
        <el-form ref="form" :rules="rules" :model="form" label-width="100px">
          <el-form-item v-if="!payAll" label="实际承运人实收运费">
            <el-input v-model="row.deliveryCashFee" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
          <el-form-item v-if="!payAll" label="已打款金额">
            <el-input v-model="row.allotAmount" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
          <el-form-item v-if="!payAll" label="已分配油点">
            <el-input v-model="row.allotOil" :disabled="true">
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="待打款金额" prop="amount">
            <el-input v-model="form.amount" disabled>
              <template slot="append">
                元
              </template>
            </el-input>
          </el-form-item>
          <!-- 请选择手机号 -->
          <el-collapse
            v-if="payAll || !compArpaPayTongLian"
            v-model="activeNames"
            style="margin-bottom: 20px"
          >
            <el-collapse-item title="请选择手机号" name="1">
              <el-radio-group
                v-for="(phone1, index) in phoneArray"
                :key="index"
                v-model="queryObj.phone"
                :disabled="queryObj.phone != ''"
              >
                <el-radio :label="phone1" style="margin-right: 10px">{{
                  phone1
                }}</el-radio>
              </el-radio-group>
            </el-collapse-item>
          </el-collapse>
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item label="获取验证码" prop="smsCode">
                <el-input v-model="form.smsCode" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <verificationCode
                ref="ishowRef"
                :api-fun="
                  !payAll && compArpaPayTongLian
                    ? sendVerificationCodeTL
                    : sendVerificationCode
                "
                :query-obj="queryObj"
                @selectItem="selectItem"
                @getSms="getSms"
              />
            </el-col>
          </el-row>
          <el-form-item>
            <el-button type="primary" :disabled="updating" @click="funcSubmit()"
              >确认打款</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <vxe-table v-if="!payAll" border height="250" :data="tableData">
      <vxe-table-column field="orderDetailNumber" title="运单号" />
      <vxe-table-column field="amount" title="分配现金" />
      <vxe-table-column field="gmtCreated" title="分配时间" />
    </vxe-table>

    <vxe-pager
      v-if="!payAll"
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="form.pageNum"
      :page-size.sync="form.pageSize"
      :total="form.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import {
  remitDefinite,
  payToDriver,
  getConfigPhone,
  sendVerificationCode,
  sendVerificationCodeTL,
  batchPayToDriver,
  payByBackSMS
} from "@/api/transport";
import { mayDecimal } from "@/utils/validate4Form.js";
import verificationCode from "@/components/verificationCode";
export default {
  name: "AllocateOil",
  components: {
    verificationCode
  },
  data() {
    return {
      phoneFlag: false,
      loading: false,
      updating: true,
      payAll: "",
      sendVerificationCode,
      sendVerificationCodeTL,
      row: {},
      tableData: [],
      activeNames: ["1"],
      phoneArray: [],
      radio: "",
      form: {
        payTypes: "3,4,5,9,10,11",
        amount: "",
        orderDetailCode: "",
        pageNum: 1,
        pageSize: 20,
        totaltotal: 0,
        payerRole: 0
      },
      configPhone: "",
      emptyForm: {},
      queryObj: {
        phone: "",
        source: "platform",
        amount: "",
        code: "",
        orderDetailCode: ""
      },
      Pagingconf: [20, 30, 50, 100, 10000],
      rules: {
        amount: [
          { required: true, message: "请输入可分配油点", trigger: "blur" },
          { min: 0, max: 10, message: "长度不超过10个字符", trigger: "blur" },
          { validator: mayDecimal, trigger: "blur" }
        ],
        smsCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 0, max: 10, message: "长度不超过10个字符", trigger: "blur" }
        ]
      }
    };
  },

  computed: {
    compArpaPayTongLian() {
      return this.$store.getters.party.arpaPayTongLian;
    },
    verificateCodeShow() {
      return this.$store.getters.verificateCodeShow;
    }
  },
  watch: {
    "form.smsCode"(val) {
      //  if(val!==''){
      //      this.updating=false
      //  }else{
      //      this.updating=true
      //  }
    }
  },
  // 判断验证码是否显示
  async mounted() {
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
    const partyType = this.$store.getters.party.partyType;
    let isShipment = partyType == "SHIPMENT" || partyType == "SHIPMENT_COMPANY";
    if (isShipment) {
      this.queryObj.source = "shipment";
    }
    //  获取配置的手机号 -设置默认手机号
    let party = this.$store.getters.party;
    this.configPhone = party.phone;
    await getConfigPhone().then(res => {
      if (res.data.length > 0) {
        this.phoneArray = res.data || [];
      }
      if (this.phoneArray.includes(this.configPhone)) {
        this.queryObj.phone = this.configPhone;
      } else {
        this.queryObj.phone = "";
      }
    });
  },
  methods: {
    //判断批量操作需要展示的内容
    getShow(payAll, item) {
      this.payAll = payAll;
      this.topFalg = false;
      if (payAll === 1) {
        this.jsonData = item;
        let amount = item.amount;
        let code = item.orderDetailCode;
        this.form.amount = amount;
        this.queryObj.amount = amount;
        this.queryObj.code = code.toString();
      }
    },
    // 验证码逻辑，打开窗口一切还原，点击手机号后当前窗口手机号不可改，打款按钮获取验证码后可点击且一直可点击，验证码倒计时结束后可重新获取验证码
    getSms(data) {
      this.phoneFlag = true;
      this.updating = false;
      Object.assign(this.form, data);
    },
    selectItem() {
      this.phoneFlag = false;
    },

    getInfo(row, flag) {
      this.queryObj.code = row.code;
      this.queryObj.orderDetailCode = row.code;
      this.form = JSON.parse(JSON.stringify(this.emptyForm));
      this.$refs.form.clearValidate();
      this.queryObj.phone = "";
      this.updating = true;
      this.form.amount = (
        row.deliveryCashFee -
        (row.allotAmount + row.allotOil)
      ).toFixed(2);
      this.queryObj.amount = this.form.amount;
      this.row = row;
      this.form.orderDetailCode = row.code;
      this.Allocationrecord();
      // 验证码倒计时清空
      this.$refs.ishowRef.show = true;
    },

    // 提交
    funcSubmit() {
      if (this.payAll === 1) {
        const rLoading = this.openLoading();
        //批量进行在线支付
        batchPayToDriver({
          orderDetailCode: this.jsonData.orderDetailCode.toString(),
          branchCode: this.jsonData.branchCode,
          phone: this.queryObj.phone,
          smsCode: this.form.smsCode
        }).then(res => {
          rLoading.close();
          if (res.status) {
            this.$message({ message: res.msg, type: "warning" });
            this.$emit("hideModel");
            rLoading.close();
            return;
          }
          this.$message({ message: res.msg, type: "success" });
          this.phoneFlag = false;
          this.$emit("hideModel");
        });
      } else {
        this.form.phone = this.queryObj.phone;
        this.$refs["form"].validate(valid => {
          if (valid) {
            this.updating = true;
            const rLoading = this.openLoading();
            if (this.compArpaPayTongLian && !this.payAll) {
              // 通联支付
              payByBackSMS(this.form).then(
                response => {
                  if (response.response == 0) {
                    this.$message({ message: response.msg, type: "success" });
                    this.phoneFlag = false;
                  }
                  rLoading.close();
                  this.$emit("hideModel");
                },
                () => (this.updating = false)
              );
            } else {
              payToDriver(this.form).then(
                response => {
                  if (response.response == 0) {
                    this.$message({ message: response.msg, type: "success" });
                    this.phoneFlag = false;
                  }
                  rLoading.close();
                  this.$emit("hideModel");
                },
                () => (this.updating = false)
              );
            }
          } else {
            return false;
          }
        });
      }
    },

    // 记录列表
    Allocationrecord() {
      this.tableData = [];
      this.loading = true;
      let formData = Object.assign({}, this.form);
      formData.amount = "";
      remitDefinite(formData).then(response => {
        this.tableData = response.data.records;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.form.total = response.data.total;
        this.loading = false;
      });
    },
    // 分页
    handlePageChange({ currentPage, pageSize }) {
      this.form.pageNum = currentPage;
      this.form.pageSize = pageSize;
      this.Allocationrecord();
    }
  }
};
</script>
